var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.partnerEditModal.isShowPopup)?_c('PartnerEdit',{attrs:{"partnerDetail":_vm.partnerEditModal.data,"isShowPopup":_vm.partnerEditModal.isShowPopup},on:{"modalCallBack":_vm.partnerModalCallBack}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }